/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { InjectionToken } from '@angular/core';

export function PlcQueryParams(object: object): string {
	const allValuesAreEmpy = Object.entries(object).every(
		([, value]) => value === null || value === undefined || value === '',
	);
	if (allValuesAreEmpy) return '';

	const stringValuesRecord: Record<string, string> = {};
	const entriesWithValue = Object.entries(object).filter(
		([, value]) => value !== null && value !== undefined && value !== '',
	);

	for (const [key, value] of entriesWithValue)
		stringValuesRecord[key] = `${value}`;

	return `?${new URLSearchParams(stringValuesRecord).toString()}`;
}

export type PlcHttpConfig = {
	apiUrl: string;
};

export const PlcHttpConfigToken = new InjectionToken<PlcHttpConfig>(
	'PlcHttpConfig',
);
